import { a as __rest, l as loadable$2, _ as __assign } from './loadable.esm-8884282c.js';
import React from 'react';

var ProxyPoints91Icon = function (_a) {
    var rest = __rest(_a, []);
    var Loaded = loadable$2(function () { return import('./Points91Icon-5c15f058.js'); });
    return React.createElement(Loaded, __assign({}, rest));
};

export { ProxyPoints91Icon as P };
